lmApp
  .controller('CdnController', ['$scope', '$rootScope', 'ToastService', 'InfrastructureService',
    function ($scope, $rootScope, ToastService, InfrastructureService) {
      $scope.data = {};
      $scope.loading = false;

      $scope.saveOriginsList = function () {
        if ($scope.loading) return;

        $rootScope.showLinearProgress('#cdnLoader');
        $scope.loading = true;
        for (var i = 0; i < $scope.data.origins.length; i++) {
          var origin = $scope.data.origins[i];

          if (origin._PrivateData.cdnUrl !== origin._PrivateData.cdnUrlOrigin) {
            InfrastructureService.UpdateOrigin(origin)
              .then(function (response) {
                $rootScope.hideLinearProgress('#cdnLoader');
                $scope.loading = false;

                ToastService.Small({
                  color: 'green',
                  title: 'CDN URLs successfully saved',
                  icon: 'swap-horizontal'
                }, 6000);
              })
              .catch(function (reason) {
                $rootScope.hideLinearProgress('#cdnLoader');
                $scope.loading = false;

                ToastService.Small({
                  color: 'red',
                  title: 'CDN URLs save failed',
                  icon: 'swap-horizontal'
                }, 6000);
              });
          }
        }
      };

      $scope.getOriginsList = function () {

        $rootScope.showLinearProgress('#cdnLoader');
        $scope.loading = true;
        InfrastructureService.GetOrigins()
          .then(function (collection) {
            $rootScope.hideLinearProgress('#cdnLoader');
            $scope.loading = false;
            $scope.data.origins = collection.map(function (origin) {
              origin._PrivateData = {};
              origin._PrivateData.cdnUrl = origin.cdn_url;
              origin._PrivateData.cdnUrlOrigin = origin.cdn_url;

              return origin;
            });
          })
          .catch(function (reason) {
            $rootScope.hideLinearProgress('#cdnLoader');
            $scope.loading = false;
          });
      };

      $scope.getOriginsList();
    }]);
